import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthorizatedGuard  {
 
  private auth = inject(AuthService);
  private router = inject(Router);


  constructor(){}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let estado:boolean = true;


    if(localStorage.getItem("token") === null){
      estado = false;
    }

  
    if(estado === false){
      this.auth.CerrarSesion();
    }

    return estado;
  }
  
}
